import React, { Component } from 'react';
import AdminColorsSalesForceTable from './AdminColorsSalesForceTable';

export class AdminColorsSalesForceContent extends Component {
  render() {

    return (
      <AdminColorsSalesForceTable titleTableList={this.props.titleTableList} />
    )

  }
}

export default AdminColorsSalesForceContent


// WEBPACK FOOTER //
// ./src/components/Administration/AdminColorSF/AdminColorsSalesForceContent.js